import LangEnum from '../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../utils/testIds/catalog.testIds';
import { CatalogCreationBooleanOptions } from '../catalogCreationForm.types';
import CatalogCreationBooleanSelectField from './CatalogCreationBooleanSelectField';

export const UNAVAILABLE_PRODUCT_COLOR_OPTIONS: CatalogCreationBooleanOptions = [
  { value: true, label: LangEnum.CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR_SHOW },
  { value: false, label: LangEnum.CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR_HIDE },
];

const CatalogCreationUnavailableProductColorField = () => (
  <CatalogCreationBooleanSelectField
    name="showUnavailableProductsForSale"
    label={LangEnum.CATALOGS_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR}
    options={UNAVAILABLE_PRODUCT_COLOR_OPTIONS}
    testId={CatalogTestIds.CATALOG_CREATION_MODAL_UNAVAILABLE_PRODUCT_COLOR}
  />
);

export default CatalogCreationUnavailableProductColorField;
